// src/components/ui/env-pill.tsx
import { Chip } from "@/components/iris";
import type { Env } from "@/lib/types";

interface EnvPillProps {
  value: Env;
  onChange: (env: Env) => void;
}

export function EnvPill({ value, onChange }: EnvPillProps) {
  return (
    <div style={{ display: "flex", gap: 4 }}>
      <Chip active={value === "dev"} onClick={() => onChange("dev")}>
        Dev
      </Chip>
      <Chip active={value === "prod"} onClick={() => onChange("prod")}>
        Prod
      </Chip>
    </div>
  );
}
